@if (formattedDescription) {
  <div [class.multi-line]="isMultiLine">
    @switch (type) {
      @case ('PoolSale') {
        Sold from
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        for {{ data.price | aacurrency }}
        @if (hasTaxableUse) {
          ({{ data.taxableUse | aapercent }} Taxable Use)
        }
      }

      @case ('PoolWriteOff') {
        Written Off from
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
      }

      @case ('AddToPool') {
        Added to
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
      }

      @case ('TransferToPool') {
        Transferred to
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
      }

      @default {
        <div [innerHTML]="formattedDescription | keepHtml"></div>
      }
    }
  </div>
}

@if (sourceText || importName) {
  <div class="source" [class.multi-line]="isMultiLine">
    {{ sourceText }}
    @if (importName) {
      <a [href]="sourceLink">{{ importName }}</a>
    }
  </div>
}
